export const extractFilenameFromUrl = (url: string): string => {
  if (!url) return '';

  // Split by '/' and get the last part
  const parts = url.split('/');
  const filename = parts[parts.length - 1];

  // Remove any query parameters if present
  return filename.split('?')[0];
};
